module.exports = __webpack_public_path__ + "img/selected1-min.8ca4711f.png";